import { createListenerMiddleware } from '@reduxjs/toolkit';
import { missionV2Api } from 'services/missionV2';
import { missionV3Api } from 'services/missionV3';
import { vehiclesV2Api } from 'services/vehiclesV2';
import type { RootState } from 'store/reducers';
import { clearSelectedVehicle, setIsVehicleDetailsOpen, setSelectedVehicle } from 'store/slices/appSlice';

export const listenerMiddleware = createListenerMiddleware<RootState>();

listenerMiddleware.startListening({
    actionCreator: clearSelectedVehicle,
    effect: async (_, listenerApi) => {
        listenerApi.dispatch(missionV2Api.util.resetApiState());
        listenerApi.dispatch(missionV3Api.util.resetApiState());
        listenerApi.dispatch(setIsVehicleDetailsOpen(false));
    },
});

listenerMiddleware.startListening({
    actionCreator: setSelectedVehicle,
    effect: async (action, listenerApi) => {
        const selectedVIN = action.payload.selectedVIN;

        // Look up the selected vehicle from the by-VIN V2 cache (getVehicleByVINV2)
        const vehicle = selectedVIN
            ? vehiclesV2Api.endpoints.getVehicleByVINV2.select(selectedVIN)(listenerApi.getState()).data
            : undefined;

        if (vehicle) {
            // Check if there is a mission assigned to the selected vehicle
            const hasMission = !!vehicle.activeMissionId?.value?.data;

            if (!hasMission) {
                // The selected (or deselected) vehicle has no mission: drop the mission cache
                // entries so the mission API unsubscribes (closes) from the websocket.
                listenerApi.dispatch(missionV2Api.util.resetApiState());
                listenerApi.dispatch(missionV3Api.util.resetApiState());
            }
        }
    },
});
